import {
  fetchCourseHistory,
  fetchMonthlyStats,
  fetchYearlyStats,
} from '@/models/statistics'
import { fetchCoursesByIds } from '@/models/content'
import { ActionTree, ActionContext } from 'vuex'
import { StatisticsState } from './state'

const actions: ActionTree<StatisticsState, {}> = {
  getCourseHistoryStats: async (
    context: ActionContext<StatisticsState, {}>
  ) => {
    try {
      const response = await fetchCourseHistory()
      context.commit('COURSE_HISTORY_STATS_UPDATED', response)
    } catch (error) {
      const { message } = error
      context.dispatch('app/setError', message, { root: true })
    }
  },

  getCoursesForHistory: async (
    context: ActionContext<StatisticsState, {}>,
    ids: Array<string>
  ) => {
    try {
      const courses = await fetchCoursesByIds(ids)
      context.commit('COURSES_FOR_HISTORY_UPDATED', courses)
    } catch (error) {
      const { message } = error
      context.dispatch('app/setError', message, { root: true })
    }
  },

  getMonthlyStats: async (context: ActionContext<StatisticsState, {}>) => {
    try {
      const response = await fetchMonthlyStats()
      context.commit('MONTHLY_STATS_UPDATED', response)
    } catch (error) {
      const { message } = error
      context.dispatch('app/setError', message, { root: true })
    }
  },

  getYearlyStats: async (context: ActionContext<StatisticsState, {}>) => {
    try {
      const response = await fetchYearlyStats()
      context.commit('YEARLY_STATS_UPDATED', response)
    } catch (error) {
      const { message } = error
      context.dispatch('app/setError', message, { root: true })
    }
  },
}

export default actions
